import { useEffect, useState } from "react";
import img1 from "../../../../assets/tempIMG1.jpg";
import img2 from "../../../../assets/tempIMG2.jpg";
import ImageSlider from "../../../UI/ImageSlider";
import styles from "./Header.module.css";

const tempImageArray = [img1, img2];

export default function Header({ galleries }) {
  const [galleryIndex, setGalleryIndex] = useState(-1);

  useEffect(() => {
    console.log("IM GERE");
    console.log(galleries);

    if (galleries && galleries.length > 0) {
      setGalleryIndex(
        galleries.findIndex((e) => e.post_name === "naslovna-galerija")
      );
    }
  }, [galleries]);

  return (
    <>
      {galleries && galleries.length > 0 && (
        <main className={styles.main}>
          <ImageSlider
            isRotating={true}
            filter={true}
            images={
              galleryIndex !== -1
                ? galleries[galleryIndex].gallery.map((e) => e.src)
                : tempImageArray
            }
          />
        </main>
      )}
    </>
  );
}
